"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../../styles/_sharing-settings.scss");

function SettingRadioButton(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      onChange = _ref.onChange,
      shareSetting = _ref.shareSetting,
      isSelected = _ref.isSelected,
      icon = _ref.icon;
  return _react["default"].createElement(_uiKit.RadioButton, {
    onChange: onChange,
    value: shareSetting,
    selected: isSelected
  }, _react["default"].createElement("div", {
    className: "share-modal-advanced__container__content__share-setting"
  }, _react["default"].createElement(_uiKit.Icon, {
    name: icon,
    size: 15
  }), _react["default"].createElement("div", {
    className: "share-modal-advanced__container__content__share-setting__text"
  }, _react["default"].createElement("p", null, title), _react["default"].createElement("p", null, subtitle))));
}

var _default = (0, _react.memo)(SettingRadioButton);

exports["default"] = _default;